import BlindInput from "app/widgets/PromptList/BlindInput";
import TextInput from "app/widgets/TextInput/TextInput";
const BlindStringPromptInput = BlindInput.extend({
    options: {
        name: "BlindStringPromptInput"
    },

    init: function(element, options) {
        BlindInput.fn.init.apply(this, arguments);
        var me = this,
            maxLength = this.options.model.maxLength,
            characterCase = this.options.model.characterCase;

        // set up a blind element and add to DOM before making widgets
        this.blindInput = this._createAndAppendBlindElement();

        // set up the main text input.
        this.decorate(this.input);
        this.widget = new TextInput(this.input, {
            characterCase: characterCase,
            maxlength: maxLength
        });
        this.widget.bind("change", this.handleChange);

        // set up a blind text input
        this.decorate(this.blindInput);
        this.blindWidget = new TextInput(this.blindInput, {
            characterCase: characterCase,
            maxlength: maxLength
        });
        this.blindWidget.bind("change", function() {
            me.options.model.set("blindValue", me.blindWidget.value());
        });

        this.refresh();
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }
        if (this.blindWidget) {
            this.blindWidget.unbind("change");
        }

        BlindInput.fn.destroy.apply(this, arguments);
    },

    // Only call readOnly when not absolutely positioned. Otherwise, enabled handling displays the readonly (disabled)
    // mode of the control. When absolutely positioned, we need to use scrolling to access the full text, rather than wrapping
    // on our own with our special readonly mode.
    readonly: function(val) {
        if (!this.options.disabledWhenReadonly) {
            BlindInput.fn.readonly.call(this, val);
        } else {
            this._readonlyEnable(val);
        }
    }
});
kendo.ui.plugin(BlindStringPromptInput);
export default BlindStringPromptInput;
